import { PurchasesByPlaceFragment } from '@generated/graphql';
import { AllIcxInfo } from '../IndustryLandList';

const BasicTable = {
  basicCompanyName: '업체명',
  fullinvestigationRegistrationNumber: '사업자 등록 번호',
  basicCity: '지역 (시도, 시군구)',
  basicComplexName: '단지명',
  fullinvestigationStreetAddress: '도로명 주소',
  basicIndustryCategory: '업종 대분류',
  basicIndustrial: '업종',
  basicIndustryMiddleCategory: '중분류',
  basicIndustryCode: '업종 코드',
  fullinvestigationAddress: '회사 홈페이지',
  fullinvestigationDivision: '설립 구분',
  fullinvestigationYear: '설립연도',
  fullinvestigationCorporationNumber: '법인 번호',
  fullinvestigationCompanyScale: '회사 규모'
};

const KeyResultTable = {
  keyresultsProduce_2020: '2020년 생산액',
  keyresultsProduce_2019: '2019년 생산액',
  keyresultsExport_2020: '2020년 수출액',
  keyresultsExport_2019: '2019년 수출액',
  keyresultsEmploy_2020: '2020년 고용',
  keyresultsEmploy_2019: '2019년 고용'
};

export type GetLavelue = (detailInfo: AllIcxInfo) => {
  label: string;
  value: string;
};

const ActivitiesProductTable = {
  activitiesProductName_1: '제품/상품명',
  activitiesProductType_1: '제품/상품 유형',
  activitiesIndustryClassification_1: '산업 분류',
  activitiesSectors_1: '업종',
  activitiesProductName_2: '제품/상품명',
  activitiesProductType_2: '제품/상품 유형',
  activitiesIndustryClassification_2: '산업 분류',
  activitiesSectors_3: '업종',
  activitiesProductName_3: '제품/상품명',
  activitiesProductType_3: '제품/상품 유형',
  activitiesIndustryClassification_3: '산업 분류',
  getActivityCharacteristic: (detailInfo: AllIcxInfo) => {
    const current =
      detailInfo.activityCharacteristics_1 ||
      detailInfo.activityCharacteristics_2 ||
      detailInfo.activityCharacteristics_3 ||
      detailInfo.activityCharacteristics_4 ||
      detailInfo.activityCharacteristics_5 ||
      detailInfo.activityCharacteristics_6;

    return {
      label: '기업체 업종 및 생산 활동 특성',
      value: activityCharacteristicSwitch(current)
    };
  },
  getPurchasesByPlace: (detailInfo: AllIcxInfo) => {
    if (detailInfo.purchasesBeforePurchase) {
      return {
        label: '구매처 별 비중',
        value: '-'
      };
    }

    return {
      label: '구매처 별 비중',
      value: getValueString(detailInfo, PlaceTableTo('purchases'))
    };
  },
  getPurchasesByCity: (detailInfo: AllIcxInfo) => {
    return {
      label: '구매처 지역별 비중',
      value: getValueString(detailInfo, CityTableTo('purchases'))
    };
  },
  getPurchasesByIndustrial: (detailInfo: AllIcxInfo) => {
    return {
      label: '주요 구매 지역별 비중',
      value: getValueString(detailInfo, IndustrialTableTo('purchases'))
    };
  },
  getVendorByPlace: (detailInfo: AllIcxInfo) => {
    return {
      label: '납품(판매처) 별 비중',
      value: getValueString(detailInfo, PlaceTableTo('vendor'))
    };
  },
  getVendorByCity: (detailInfo: AllIcxInfo) => {
    return {
      label: '납품(판매처) 지역별 비중',
      value: getValueString(detailInfo, CityTableTo('vendor'))
    };
  },
  getVendorByIndustrial: (detailInfo: AllIcxInfo) => {
    return {
      label: '주요 납품(판매처) 지역별 비중',
      value: getValueString(detailInfo, IndustrialTableTo('vendor'))
    };
  }
};

const InformationTable = {
  fullinvestigationName_1: '이름',
  fullinvestigationCall: '전화번호',
  fullinvestigationFax: '팩스',
  fullinvestigationEmail: '이메일'
};

const RndTable = {
  rndWhether: '연구 개발 조직',
  rndInvestment_2020: '2020년 연구 개발 투자 (백만원)',
  rndPatentApplication_2020: '2020년 특허 출원 (건)',
  rndPatentRegistration_2020: '2020년 특허 등록 (건)',
  rndInvestment_2019: '2019년 연구 개발 투자 (백만원)',
  rndPatentApplication_2019: '2019년 특허 출원 (건)',
  rndPatentRegistration_2019: '2019년 특허 등록 (건)'
};

const ProductionPerformanceTable = {
  productionPerformance_2020Cost: '2020년 생산액 / 매출액',
  productionPerformance_2019Cost: '2020년 생산액 / 매출액'
};

const ExportPerformanceTable = {
  exportPerformance2020ExportCost: '2020년 수출액',
  exportPerformance2019ExportCost: '2019년 수출액',
  exportCountryUsa: 'Usa',
  exportCountryChina: 'China',
  exportCountryJapan: 'Japan',
  exportCountrySoutheastAsia: 'SoutheastAsia',
  exportCountryEurope: 'Europe',
  exportCountryMiddleEast: 'MiddleEast',
  exportCountryLatinAmerica: 'LatinAmerica',
  exportCountryOthers: 'Others'
};

const EmployeesTable = {
  employees2020FullTimeTotal: '2020년 자사 소속',
  employees2019FullTimeTotal: '2019년 자사 소속',
  thirdPartyEmployees2020DispatchedTotal: '2020년 타사 소속',
  thirdPartyEmployees2019DispatchedTotal: '2019년 타사 소속'
};

export {
  RndTable,
  BasicTable,
  EmployeesTable,
  KeyResultTable,
  InformationTable,
  ActivitiesProductTable,
  ExportPerformanceTable,
  ProductionPerformanceTable
};

const activityCharacteristicSwitch = (d?: string | null) => {
  switch (d) {
    case '1':
      return '제조업으로 직접생산활동수행';
    case '2':
      return '제조업이나 직접 생산활동 없이 제조업 관련 매출 발생';
    case '3':
      return '비제조업으로 출판,정보통신,전문지식서비스업 수행 관련 매출 발생';
    case '4':
      return '비제조업으로 물류, 운송, 장비임대같은 판매 및 서비스제공을 통한 매출 발생';
    case '5':
      return '생산 및 매출발생활동 없이 내부 연구업무만 담당하거나 지원활동만 수행';
    case '6':
      return '기타';
    default:
      return '-';
  }
};

const getValueString = (
  detailInfo: AllIcxInfo,
  table: { [key: string]: string }
) =>
  Object.entries(table)
    .map(([key, value]) =>
      Number(detailInfo[key as keyof AllIcxInfo])
        ? `${value}(${detailInfo[key as keyof AllIcxInfo]})`
        : null
    )
    .filter((v) => v)
    .join(' - ');

// subTable
const PlaceTableTo = (type: 'purchases' | 'vendor') => ({
  [`${type}LargeBusiness`]: '대기업',
  [`${type}SmallBusiness`]: '중소기업',
  [`${type}Government`]: '정부, 공공기관',
  [`${type}University`]: '대학',
  [`${type}Headquarters`]: '본사, 타사업장',
  [`${type}OversearImport`]: '해외 직수입',
  [`${type}IndividualUnspecifiedMajority`]: '개인 및 불특정 다수',
  [`${type}Others`]: '기타',
  [`${type}BeforePurchase`]: '구매 발생전'
});

const CityTableTo = (type: 'purchases' | 'vendor') => ({
  [`${type}Seoul`]: '서울',
  [`${type}Busan`]: '부산',
  [`${type}Tegu`]: '대구',
  [`${type}Incheon`]: '인천',
  [`${type}Gwangju`]: '광주',
  [`${type}Daejon`]: '대전',
  [`${type}Ulsan`]: '울산',
  [`${type}Sejong`]: '세종',
  [`${type}Kyonggi`]: '경기',
  [`${type}Kangwon`]: '강원',
  [`${type}Chungbuk`]: '충북',
  [`${type}Chungnam`]: '충남',
  [`${type}Jeonbuk`]: '전북',
  [`${type}Chonnam`]: '전남',
  [`${type}Kyongbok`]: '경북',
  [`${type}Kyongnam`]: '경남',
  [`${type}Jeju`]: '제주'
});

const IndustrialTableTo = (type: 'purchases' | 'vendor') => ({
  [`${type}IndustrialComplex1`]: '현재 입주 산단',
  [`${type}IndustrialComplex2`]: '동일 시도 내 산단',
  [`${type}IndustrialComplex3`]: '타 시도 내 산단',
  [`${type}Others2`]: '기타'
});
